import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMailboxUserList, removeMailboxUserFromStore } from "../../../../../src/actionCreators/commonActionCreators";
import { HamburgerIcon, ViewInboxIcon } from "../../../../../src/assets/images/svg/IconCollection";
import { ViewOthersInboxModalConstants } from "../../../../../src/Core/Common/Constants";
import { viewingOthersInboxLabel } from "../../../../../src/helper/HelperFunctions";
import { ApplicationState } from "../../../../../src/store";
import { ViewInboxModal } from "../../Modal/AdminSettingsModals/ViewInboxModal";
import { ResourceIdLocators } from "../../../../../src/helper/ResourceIdLocators";

interface IInboxHeaderProps {
    showSideMenuHandler: () => void;
    headerTitle: string;
}

const InboxHeader: React.FC<IInboxHeaderProps> = props => {
    const { exchangeEnabled } = useSelector((state: ApplicationState) => state.postAuthState);
    const { mailboxUserData } = useSelector((state: ApplicationState) => state.commonState);
    const [showViewInboxModal, setshowViewInboxModal] = useState(false);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(removeMailboxUserFromStore());
    }, []);
    const clearViewInboxModalState = () => {
        setshowViewInboxModal(false);
    };
    const showViewInboxModalHandler = () => {
        setshowViewInboxModal(true);
        dispatch(fetchMailboxUserList());
    };

    const exitOthersMailboxViewHandler = () => {
        dispatch(removeMailboxUserFromStore());
    };
    return (
        <header className="inbox-header">
            <div className="flex-row">
                <div className="icon-title-wrapper">
                    <span onClick={props.showSideMenuHandler}>
                        <HamburgerIcon />
                    </span>
                    {exchangeEnabled && <span>{props.headerTitle}</span>}
                </div>

                {exchangeEnabled && (
                    <span 
                        title={ViewOthersInboxModalConstants.ICON_TITLE} 
                        data-resource-id={ResourceIdLocators.Global.ViewOtrInboxBtn}
                        onClick={showViewInboxModalHandler}
                    >
                        <ViewInboxIcon width={20} height={21}/>
                    </span>
                )}
            </div>

            {mailboxUserData && (
                <div className="others-inbox-label-wrapper">
                    <span title={viewingOthersInboxLabel(mailboxUserData.firstName,mailboxUserData.lastName)} className="truncate">
                        {viewingOthersInboxLabel(mailboxUserData.firstName,mailboxUserData.lastName)}
                    </span>
                    <p onClick={exitOthersMailboxViewHandler}>Exit</p>
                </div>
            )}
            {showViewInboxModal && (
                <ViewInboxModal showViewInboxModal={showViewInboxModal} clearModalState={clearViewInboxModalState} />
            )}
        </header>
    );
};
export default InboxHeader;
